import { createContext } from "react"

const Auth = createContext({})

export default Auth
